import { Currency, formatBalance, formatDate } from '@ui/src';
import { FintracTransaction } from '../types';

import cn from '../styles.module.css';

const formatFintracTransactions = (
  list: FintracTransaction[],
  currencies?: Currency[],
  cadCurrency?: Currency,
): FintracTransaction[] => {
  const nextList = list?.map((item) => {
    const result = { ...item };

    const currenctCurrency = currencies?.find(
      (currency) => currency.id === result.currencyId,
    );

    const render: Record<string, React.JSX.Element> = {
      transferDate: (
        <div>
          {result?.transferDate ? formatDate(result.transferDate, true) : '-'}
        </div>
      ),
      currencyId: <div>{currenctCurrency?.name}</div>,
      sum: (
        <div>
          {result.sum ? formatBalance(result.sum, currenctCurrency) : '0'}
        </div>
      ),
      convertedAmount: (
        <div>
          {result.convertedAmount
            ? formatBalance(result.convertedAmount, cadCurrency)
            : '0'}
        </div>
      ),
      beneficiaryId: (
        <div className={cn.beneficiaryWrapper}>
          <div className={cn.beneficiaryContent}>
            <div className={cn.beneficiaryName}>
              {`${result.beneficiaryGivenName} ${result.beneficiarySurname}`}
            </div>
            <div className={cn.beneficiaryFullNumber}>
              {result?.beneficiaryAccountNumber}
            </div>
          </div>
        </div>
      ),
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatFintracTransactions;
